import { render } from "./login.html?vue&type=template&id=a6e32aca&ts=true"
import script from "./login.ts?vue&type=script&lang=ts"
export * from "./login.ts?vue&type=script&lang=ts"

import "./login.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__